import * as types from './types'
import global from '@/plugins/global'

export default {
  [types.SET_PAGE_SIZE](state, value) {
    if (value !== undefined && value !== null) {
      state.pageSize = parseInt(value)
    }
  },
  [types.SET_SEARCH_TERM](state, text) {
    if (text !== undefined && text !== null) {
      state.searchTerm = text
    }
  },
  [types.SET_SORT_DIR](state, text) {
    if (text !== undefined && text !== null) {
      state.sortDir = text
    }
  },
  [types.SET_ORDER_BY](state, text) {
    if (text !== undefined && text !== null) {
      state.orderBy = text
    }
  },
  [types.SET_FILTER_BY](state, value) {
    if (value !== undefined && value !== null) {
      state.filterBy = parseInt(value)
    }
  },
  [types.SET_FILTER_OPTIONS](state, data) {
    state.filterOptions = [{
      name: 'Available',
      value: 1
    },
    // {
    //   name: 'Unavailable',
    //   value: 2
    // },
    {
      name: 'Away',
      value: 0
    },
    {
      name: 'All',
      value: 99
    },
    {
      name: 'Work Orders',
      value: 100
    }
    ]
    if (data.viewing === 'DispatchQueue') {
      state.filterOptions.splice(-1, 1)
    }
  },
  [types.SET_TECHNICIAN](state, data) {
    state.technician = data
  },
  [types.SET_TECHNICIANS](state, data) {
    try {
      if (data !== undefined && data !== null) {
        if (data.items !== null) {
          for (let tech of data.items) {
            tech.elapsedTime = global.dates.elapsedTime(tech.userStatusDate, tech.dispatchStatus, tech.workOrderStatus)
          }
        }
      }
    } catch (e) {
      console.error(e)
    }
    state.technicians = data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/technicians/mutations.js